import request from '@/utils/request'


// 查询设备灯光设置列表
export function listLightSetting(query) {
  return request({
    url: '/mibo/device-light-setting/list',
    method: 'get',
    params: query
  })
}

// 查询设备灯光设置分页
export function pageLightSetting(query) {
  return request({
    url: '/mibo/device-light-setting/page',
    method: 'get',
    params: query
  })
}

// 查询设备灯光设置详细
export function getLightSetting(data) {
  return request({
    url: '/mibo/device-light-setting/detail',
    method: 'get',
    params: data
  })
}

// 新增设备灯光设置
export function addLightSetting(data) {
  return request({
    url: '/mibo/device-light-setting/add',
    method: 'post',
    data: data
  })
}

// 修改设备灯光设置
export function updateLightSetting(data) {
  return request({
    url: '/mibo/device-light-setting/edit',
    method: 'post',
    data: data
  })
}

// 删除设备灯光设置
export function delLightSetting(data) {
  return request({
    url: '/mibo/device-light-setting/delete',
    method: 'post',
    data: data
  })
}
